// クラシック版の第1世代の柄（mono。段階 C の2 の 7e。2026-10-26 に画面ファイル gen1-pattern.js から描き直した。動きは前と同じ）。
// 色の欄の中に出す柄の一覧と色の入れかえ（旧式の柄。柄は 1 つで、色の入れかえは柄の中の色を入れかえて作り直す）。CHOCO と同じ front 型の画面（gen1b）に足して使う。
// 使う設定: PATTERN_IN_COLOR: true（mono。main.ts はこのときだけ置く）・MODE_PATTERN。カテゴリの CMODE 列（[色, 柄]）と、getcategory が返す PATTERN が要る。
// 置くもの: chibi の selColor・btnEditColor・setPatternList・selPattern・clearPattern・setPattern・changePattern・copyPattern・btnRevColor・setPartsColorPattern、
// charat.common の changePattern・makePattern（1 柄の版）。d3（style の読み取りは計算された値も見る）と jQuery は fx.d3any・fx.jq でそのまま
import { chibi, common } from './engine.js';
import * as fx from './fx.js';
import { S } from './sel.js';
import * as jq from './jq.js';

type Engine = Record<string, any>;
const E = (): Engine => chibi() as unknown as Engine;
const C = (): Record<string, any> => common() as unknown as Record<string, any>;
const FILL = 'fill', STROKE = 'stroke';
/** レイヤー（背景は背景の SVG） */
const layerOf = (layerName: string): any => (layerName == E().PARTS_BG ? E().svgBg : E().svgMake).select('#' + E().ATTR_LAYER + layerName);
/** カテゴリの色を入れかえる（背景は背景の SVG） */
const revColor = (category: any, rev: unknown): void => {
  const e = E();
  C().changeRevColor(category.LAYER[0] == e.PARTS_BG ? e.svgBg : e.svgMake, category, e.ATTR_LAYER, rev, e.COLOR_EX1, e.COLOR_EX2, e.COLOR_STROKE1, e.COLOR_STROKE2, e.btnSubSelect.STATUS);
};
/** カテゴリに柄を塗る・外す（aPatternId が null なら外す） */
const paint = (category: any, aPatternId: string | null, rev: unknown, mode: unknown): void => {
  const e = E();
  C().changePattern(category.LAYER[0] == e.PARTS_BG ? e.svgBg : e.svgMake, category, e.ATTR_LAYER, aPatternId, rev, mode, e.COLOR_EX1, e.COLOR_EX2, e.COLOR_STROKE1, e.COLOR_STROKE2, e.btnSubSelect.STATUS);
};

/** カテゴリを選んだときの色の欄。CMODE で色（[0]）と柄（[1]）のどちらを出すかを決め、色のボタンで開く欄を切りかえる */
export function selColor(aCategory: any): void {
  const e = E();
  e.enableEditColor = aCategory.CMODE[0] != 0;
  e.enableEditPattern = aCategory.CMODE[1] != 0;
  const isValidCol = (e.enableEditColor && aCategory.COLOR.length > 0) || aCategory.GRAD.length > 0;
  const isValidGrad = e.enableEditColor && aCategory.GRAD.length > 0;
  const nowValidGrad = e.svgGrad.attr('display') != 'none';
  if (isValidCol) {
    if (aCategory.COLOR.length > 0) {
      e.svgColor.select('circle#' + e.ATTR_CCOLOR + '_').attr('style', 'fill:' + aCategory.COLOR[0] + ';stroke-opacity:1;stroke-width:2;stroke:' + (aCategory.COLOR.length > 1 ? aCategory.COLOR[1] : e.COLOR_ACTIVE));
    } else if (aCategory.GRAD.length > 0) {
      e.svgColor.select('circle#' + e.ATTR_CCOLOR + '_').attr('style', 'fill:' + aCategory.GRAD[1] + ';stroke-opacity:1;stroke-width:2;stroke:' + aCategory.GRAD[0]);
    }
  }
  jq.setCss(e.DIV_F_GRAD, 'left', jq.width(e.DIV_F_COLOR_SC));
  e.svgColor.attr('display', e.enableEditColor ? 'inline' : 'none');
  e.svgPickColor.attr('display', e.enableEditColor ? 'inline' : 'none');
  e.svgPattern.attr('display', e.enableEditPattern ? 'inline' : 'none');
  e.svgPickPattern.attr('display', e.enableEditPattern ? 'inline' : 'none');
  if (isValidGrad) {
    e.svgGrad.attr('display', 'inline');
    jq.fadeIn(e.DIV_F_GRAD, 100);
  } else if (nowValidGrad) {
    jq.fadeOut(e.DIV_F_GRAD, 100, () => {
      E().svgGrad.attr('display', 'none');
    });
  }
  if (e.enableEditColor || e.enableEditPattern) e.btnEditColor.ON();
  else e.btnEditColor.OFF();
  if (isValidCol) {
    const pcol = e.selLayer.attr('paramCol');
    const sbar = e.DIV_F_COLOR;
    if (pcol != '') {
      const pcolpos = 'circle#' + e.ATTR_CCOLOR + pcol.replace('#', '_');
      if (jq.els(pcolpos).length > 0) jq.animate(sbar, { scrollTop: Math.max(0, jq.offset(pcolpos)!.top - jq.offset(sbar)!.top) }, 'fast');
      else jq.animate(sbar, { scrollTop: 0 }, 'fast');
    }
  }
  if (isValidGrad) {
    let pfrom = e.selLayer.attr('paramColFrom');
    let pto = e.selLayer.attr('paramColTo');
    if (pfrom == '') pfrom = aCategory.GRAD[1];
    if (pto == '') pto = aCategory.GRAD[0];
    S
      .select('#' + e.ATTR_GRAD_FROM + ' rect')
      .style('fill', pfrom);
    S
      .select('#' + e.ATTR_GRAD_TO + ' rect')
      .style('fill', pto);
    C().setGradColor('#' + e.ATTR_GRAD_BAR, [0, 1], [pfrom, pto]);
    e.setGradFromTo('#' + e.ATTR_GRAD_FROM, true);
    e.setGradFromTo('#' + e.ATTR_GRAD_TO, false);
  }
}

/** ボタンの定義（色のボタン・色の入れかえ）を作る */
export function makeGen1PatternButtons(): Record<string, unknown> {
  const e = E();
  const P = e.PATH_IMG;
  return {
    // 色のボタン: 色の無いカテゴリでは色の欄の代わりに柄の欄を開く
    btnEditColor: {
      ID: e.ATTR_EDITMENUBUTTON + 'Color',
      STATUS: 0,
      FILE: [P + 'ico_right/color.svg'],
      CLICK: () => {
        const b = E().btnEditColor;
        if (b.STATUS == 0) b.OFF();
        else {
          b.ON();
          if (b.STATUS == 1 && E().btnEditSub.STATUS == 1) fx.d3ClickCall('#' + E().btnEditSub.ID + 'click', { BTN: E().btnEditSub });
        }
      },
      ON: () => {
        const en = E();
        if (en.btnEditColor.STATUS != 1) return;
        if (en.enableEditColor) {
          jq.setCss(en.DIV_F_COLORAREA, 'display', 'inline');
          jq.setCss(en.DIV_F_COLORAREA, 'opacity', 1);
          jq.setCss(en.DIV_F_PATTERNAREA, 'opacity', 0);
          jq.setCss(en.DIV_F_PATTERNAREA, 'display', 'none');
        } else if (en.enableEditPattern) {
          jq.setCss(en.DIV_F_COLORAREA, 'opacity', 0);
          jq.setCss(en.DIV_F_COLORAREA, 'display', 'none');
          jq.setCss(en.DIV_F_PATTERNAREA, 'display', 'inline');
          jq.setCss(en.DIV_F_PATTERNAREA, 'opacity', 1);
        }
      },
      OFF: () => {
        const en = E();
        if (en.btnEditColor.STATUS != 0) return;
        jq.setCss(en.DIV_F_COLORAREA, 'opacity', 0);
        jq.setCss(en.DIV_F_COLORAREA, 'display', 'none');
        jq.setCss(en.DIV_F_PATTERNAREA, 'opacity', 0);
        jq.setCss(en.DIV_F_PATTERNAREA, 'display', 'none');
      },
    },
    // 色の入れかえ（柄の一覧の上）: 柄があれば柄の色の入れかえを 1 つ進めて作り直し、無ければグループのカテゴリの色を入れかえる
    btnRevColor: {
      NAME: 'REV_COLOR',
      STATUS: 0,
      FILE: [P + 'switch/bt_inverse.svg'],
      CLICK: () => {
        const en = E();
        if (!en.enableEditPattern) return;
        const ptnId = en.selLayer.attr('paramPtn');
        if (ptnId != undefined && ptnId != '') {
          let ptnRev: any = en.selLayer.attr('paramPrev');
          if (++ptnRev > en.MODE_COLREV) ptnRev = 0;
          en.selLayer.attr('paramPrev', ptnRev);
          en.setPattern(ptnId);
        } else {
          en.groupCategory.forEach((category: any) => {
            let layerRev: any = 0;
            category.LAYER.forEach((layerName: string) => {
              const layer = layerOf(layerName);
              layerRev = layer.attr('paramPrev');
              if (++layerRev > en.MODE_COLREV) layerRev = 0;
              layer.attr('paramPrev', layerRev);
            });
            revColor(category, layerRev);
          });
        }
      },
    },
  };
}

/** 柄の一覧: 色の欄と同じ所に、白（柄なし）と柄の丸を縦に並べ、上に色の入れかえのボタン。柄は保存用の SVG の defs に作っておく */
export function setPatternList(aPatternList: ArrayLike<Element>, aW: number, aH: number): void {
  const e = E();
  jq.setHeight(e.DIV_F_PICKPATTERN, jq.width(e.DIV_F_PICKPATTERN));
  jq.setHeight(e.DIV_F_PATTERN_SC, jq.height(e.DIV_F_PATTERN) - jq.height(e.DIV_F_PICKPATTERN));
  const fwidth = aH / 12;
  const fmargin = aH / 34;
  const cCircle = aH / 2.2;
  const cSize = aH / 2.5;
  e.svgPickPattern = C().getD3SVG(e.DIV_F_PICKPATTERN, e.DIV_F_PICKPATTERN, aW, aH);
  C().makeFloatButton({
    LAYER: e.svgPickPattern,
    CLASS: e.ATTR_EDITFLOATBUTTON,
    VISIBLE: true,
    REAR: 'circle',
    DATA: [{ BTN: e.btnRevColor, POS: { X: aW * 0.09, Y: aH * 0.05 }, SIZE: { W: aW * 0.9, H: aH * 0.9 }, SCALE: 1, COLOR: ['transparent', 'transparent'] }],
  });
  const saveDef = S.select('#' + e.SVG_SAVE + ' defs');
  const patternIds = ['000'];
  for (let s = 0; s < aPatternList.length; s++) {
    patternIds.push(aPatternList[s].id);
    const src = aPatternList[s];
    saveDef
      .append('pattern')
      .attr('id', e.ATTR_CPATTERN + src.id)
      .attr('patternUnits', 'userSpaceOnUse')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', e.SIZE_PATTERN)
      .attr('height', e.SIZE_PATTERN)
      .append('g')
      .attr('transform', 'translate(' + e.ADJUST_PATTERN + ',' + e.ADJUST_PATTERN + '), scale(1,1)')
      .append(() => src.cloneNode(true) as Element);
  }
  e.svgPattern = C().getD3SVG(e.DIV_F_PATTERN, e.SVG_PATTERN, aW, (patternIds.length + 4) * aH);
  e.svgPattern.attr('display', 'none');
  e.svgPattern
    .selectAll('circle')
    .data(patternIds)
    .enter()
    .append('circle')
    .attr('id', (d: string) => e.SVG_PATTERN + d)
    .attr('cx', () => fwidth + cCircle)
    .attr('cy', (_d: string, i: number) => i * (aH + fmargin) + fwidth + cCircle)
    .attr('r', cCircle)
    .attr('style', (d: string) => 'stroke: #C7D9E8; stroke-width: 2; fill:' + (d === '000' ? 'White' : 'url(#' + e.ATTR_CPATTERN + d + ')'))
    .style('cursor', 'pointer')
    .on('click', (_d: string, i: number) => {
      if (E().enableEditPattern) E().selPattern(i);
    });
  e.cursorPattern = [0, 1].map(() => ({ baseCsize: cSize, baseX: fwidth + cCircle, baseY: fwidth + cCircle, baseW: aW, baseH: aH + fmargin, stroke: e.COLOR_CURSOR, strokewidth: fwidth }));
  e.cursorPattern.forEach((dd: any) => {
    e.svgPattern.append('circle').attr('class', 'SelColor').attr('cx', dd.baseX).attr('cy', dd.baseY).attr('r', dd.baseCsize).attr('fill', 'none').attr('stroke', dd.stroke).attr('stroke-width', dd.strokewidth);
  });
  if (!e.isMobile) fx.scrollbarY(e.DIV_F_PATTERN_SC);
}

/** 柄の一覧の丸を押したとき（0 は柄なし） */
export function selPattern(aPtnIndex: number): void {
  const e = E();
  if (e.patternList.length == 0 || aPtnIndex < 0) return;
  e.svgPattern
    .selectAll('circle.SelColor')
    .attr('cy', (_d: unknown, i: number) => e.cursorPattern[i].baseY + aPtnIndex * e.cursorPattern[i].baseH)
    .attr('r', (_d: unknown, i: number) => e.cursorPattern[i].baseCsize * (i * 1.5))
    .attr('stroke', (_d: unknown, i: number) => (i == 0 ? '#882244' : '#00FFFF'))
    .transition()
    .duration(200)
    .ease(S.easeElastic)
    .attr('stroke', e.COLOR_CURSOR)
    .attr('r', (_d: unknown, i: number) => e.cursorPattern[i].baseCsize);
  if (aPtnIndex == 0) {
    e.clearPattern();
  } else {
    const pattern = e.patternList[aPtnIndex - 1];
    if (e.selLayer.attr('paramPtn') != pattern.id) e.setPattern(pattern.id);
  }
}

/** 柄を外す（グループのカテゴリ全部。キャラの一覧のカテゴリでは値だけ） */
export function clearPattern(): void {
  const e = E();
  const ptnMode = 0, ptnRev = 0;
  e.selLayer.attr('paramPtn', '').attr('paramPtnMode', ptnMode).attr('paramPrev', ptnRev);
  if (e.selCategory.LAYER[0] == e.PARTS_CHARA) return;
  e.groupCategory.forEach((category: any) => {
    category.LAYER.forEach((layerName: string) => {
      layerOf(layerName).attr('paramPtn', '').attr('paramPtnMode', ptnMode).attr('paramPrev', ptnRev);
    });
    paint(category, null, ptnRev, ptnMode);
  });
}

/** 柄を付ける（グループのカテゴリ全部に同じ柄。はじめて付けるときは、そのときの色の入れかえを柄のモードとして覚える） */
export function setPattern(aPtnId: string): void {
  const e = E();
  const ptnRev = e.selLayer.attr('paramPrev');
  if (e.selLayer.attr('paramPtn') == undefined || e.selLayer.attr('paramPtn') === '') e.selLayer.attr('paramPtnMode', ptnRev);
  const ptnMode = e.selLayer.attr('paramPtnMode');
  e.selLayer.attr('paramPtn', aPtnId);
  const patternId = e.ATTR_CPATTERN + '_' + e.selCategory.LAYER[0];
  if (e.copyPattern(patternId, aPtnId, ptnRev, ptnMode)) {
    if (e.selCategory.LAYER[0] != e.PARTS_CHARA) {
      e.groupCategory.forEach((category: any) => {
        e.changePattern(patternId, category, aPtnId, ptnRev, ptnMode);
      });
    }
  }
}

/** カテゴリの各レイヤーに柄の値を入れ、色の入れかえと柄を掛ける */
export function changePatternChibi(aPatternId: string, aCategory: any, aPtnId: string, aPtnRev: unknown, aPtnMode: unknown): void {
  aCategory.LAYER.forEach((layerName: string) => {
    layerOf(layerName).attr('paramPtn', aPtnId).attr('paramPtnMode', aPtnMode).attr('paramPrev', aPtnRev);
  });
  revColor(aCategory, aPtnRev);
  paint(aCategory, aPatternId, aPtnRev, aPtnMode);
}

/** 柄 aPtnId を保存用の SVG の defs に aPtnDefId として作る（色の入れかえつき。柄のモードがあれば入れかえを逆に）。柄が見つかれば true */
export function copyPattern(aPtnDefId: string, aPtnId: string, aPtnRev: any, aPtnMode: any): boolean {
  const e = E();
  const saveDef = S.select('#' + e.SVG_SAVE + ' defs');
  let pattern: Element | null = null;
  for (let i = 0; i < e.patternList.length; i++) {
    if (e.patternList[i].id == aPtnId) {
      pattern = e.patternList[i];
      break;
    }
  }
  if (aPtnMode != 0) aPtnRev = aPtnRev == 0 ? 1 : 0;
  if (pattern == null) return false;
  if (aPtnRev != 0) C().makePattern(saveDef, pattern, aPtnDefId, aPtnRev, e.COLOR_EX1, e.COLOR_EX2, e.COLOR_STROKE1, e.COLOR_STROKE2);
  else C().makePattern(saveDef, pattern, aPtnDefId);
  return true;
}

/** 柄・色の入れかえをパーツに掛ける（パーツを替えたとき・読み込み）。柄なしで入れかえだけ／柄あり */
export function setPartsColorPattern(aSvgImage: any, aCategory: any, aPtn: string, aPtnRev: any, aPtnMode: any, _aColor: string): void {
  const e = E();
  if (aPtnRev != 0 && aPtn == '') {
    C().changeRevColor(aSvgImage, aCategory, e.ATTR_LAYER, aPtnRev, e.COLOR_EX1, e.COLOR_EX2, e.COLOR_STROKE1, e.COLOR_STROKE2, e.btnSubSelect.STATUS);
  } else if (aPtn != '') {
    const patternId = e.ATTR_CPATTERN + '_' + aCategory.LAYER[0];
    if (e.copyPattern(patternId, aPtn, aPtnRev, aPtnMode)) e.changePattern(patternId, aCategory, aPtn, aPtnRev, aPtnMode);
  }
}

// ---- charat.common（1 柄の版） ----

/** 柄を塗る・外す（1 柄の版）。カテゴリの基本色（COLOR[0]）の所を柄で塗る（色は orgb に覚えて、外すときに戻す） */
export function changePattern(aSvgImage: any, aCategory: any, aLayerKey: string, aPatternId: string | null, _aPtnRev: unknown, aPtnMode: unknown, aColor1: string, aColor2: string): void {
  if (aSvgImage == null) return;
  let baseRgb = C().convToRgb(aCategory.COLOR[0]);
  const revRgb = C().convToRgb(aCategory.COLOR[0].toLowerCase() == aColor1.toLowerCase() ? aColor2 : aCategory.COLOR[0]);
  if (aPtnMode != 0) baseRgb = revRgb;
  const chgElement = 'path,ellipse,polygon,circle,rect,line,polyline';
  aCategory.LAYER.forEach((d: string) => {
    const gLayer = aSvgImage.select('#' + aLayerKey + d);
    if (aPatternId != null) {
      gLayer.selectAll(chgElement).each(function (this: Element) {
        const sel = S.select(this);
        const orgb = sel.attr('orgb');
        if (orgb == baseRgb) sel.style(FILL, 'url(#' + aPatternId + ')');
        else if (orgb != undefined && orgb !== '') {
          // 別の色で覚えているものはそのまま
        } else if (sel.style(FILL) == baseRgb) {
          sel.attr('orgb', sel.style(FILL));
          sel.style(FILL, 'url(#' + aPatternId + ')');
        }
      });
    } else {
      gLayer.selectAll(chgElement).each(function (this: Element) {
        const sel = S.select(this);
        if (sel.attr('orgb') != undefined && sel.attr('orgb') !== '') {
          sel.style(FILL, sel.attr('orgb'));
          sel.attr('orgb', '');
        }
        if (sel.attr('ostroke') != undefined && sel.attr('ostroke') !== '') {
          sel.style(STROKE, sel.attr('ostroke'));
          sel.attr('ostroke', '');
        }
      });
    }
  });
}

/** 柄を defs に作る（1 柄の版）。aPtnRev 1 は指定の色の入れかえ、2 は色の反転 */
export function makePattern(aDef: any, sPattern: Element, aPtnDefId: string, aPtnRev?: unknown, aRevCol1?: string, aRevCol2?: string, aRevStrokeCol1?: string, aRevStrokeCol2?: string): void {
  const e = E(), c = C();
  let clipptn = aDef.select('#' + aPtnDefId + ' > g');
  if (clipptn.size() == 0) {
    clipptn = aDef
      .append('pattern')
      .attr('id', aPtnDefId)
      .attr('patternUnits', 'userSpaceOnUse')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', e.SIZE_PATTERN)
      .attr('height', e.SIZE_PATTERN)
      .append('g')
      .attr('transform', () => 'translate(' + e.ADJUST_PATTERN + ',' + e.ADJUST_PATTERN + '), scale(1,1)');
  } else {
    clipptn.select('g').remove();
  }
  clipptn.append(() => sPattern.cloneNode(true));
  if (aPtnRev == undefined) return;
  if (aPtnRev == 2) {
    clipptn.selectAll('path,ellipse,polygon,circle,rect').each(function (this: Element) {
      const sel = S.select(this);
      const orgcol = sel.style(FILL);
      if (orgcol != undefined) sel.style(FILL, c.inverseColor(c.convToHexRgb(orgcol)));
      const orgstroke = sel.style(STROKE);
      if (orgstroke != undefined) sel.style(STROKE, c.inverseColor(c.convToHexRgb(orgstroke)));
    });
  } else if (aPtnRev == 1) {
    clipptn.selectAll('path,ellipse,polygon,circle,rect').each(function (this: Element) {
      const sel = S.select(this);
      const orgcol = sel.style(FILL);
      if (orgcol != undefined) {
        const hexOrgCol = c.convToHexRgb(orgcol);
        if (hexOrgCol === aRevCol1) sel.style(FILL, aRevCol2);
        else if (hexOrgCol === aRevCol2) sel.style(FILL, aRevCol1);
      }
      const orgstroke = sel.style(STROKE);
      if (orgstroke != undefined) {
        const hexOrgStroke = c.convToHexRgb(orgstroke);
        if (hexOrgStroke === aRevStrokeCol1) sel.style(STROKE, aRevStrokeCol2);
        else if (hexOrgStroke === aRevStrokeCol2) sel.style(STROKE, aRevStrokeCol1);
      }
    });
  }
}
